// extracted by mini-css-extract-plugin
export default {"imageContainer":"I2-z","summaryPar":"J2-z","ratingCategories":"K2-z","reviewerInfo":"L2-z","reviewTypes":"M2-z","expanded":"N2-z"};